<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="6">
              <h4 class="card-title mb-0">Homepage Banner</h4>
            </CCol>
            <CCol sm="6" class="card-title text-right" style="color: #2468F6;">
              <div style="cursor: pointer;">
                <CIcon name="cil-cloud-download" class="mr-1"/>
                <span @click="downloadMe()">Download Banner Guideline</span>
              </div>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <TryAgain @click="tryMeAgain()" v-if="err !== ''"></TryAgain>
          <CRow v-else>
            <CCol col="12">
              <FormBanner field="Desktop Banner" :value="valueForm.desktop" class="mb-5"
                          :expected-image-height-width="imageHeightWidthValidate.desktop"
                          :previous-image="data.main_desktop_image"
                          @retrieve-file="retrieveDataDesktop"
              />
              <FormBanner field="Mobile Banner" :value="valueForm.mobile" class="mb-5"
                          :expected-image-height-width="imageHeightWidthValidate.mobile"
                          :previous-image="data.main_mobile_image"
                          @retrieve-file="retrieveDataMobile"
              />
              <CInput
                  label="ALT Banner"
                  type="text"
                  horizontal
                  placeholder="ALT Banner"
                  v-model="data.alt_text_image"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter v-if="err === ''">
          <CRow>
            <CCol sm="5">
              <CButton color="primary" v-if="!isSave || isEmpty" @click="$router.go(-1)">Back</CButton>
              <CButton color="primary" v-else @click="fetchDataBanner()">Cancel</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  @click="saveBanner()"
                  v-if="isSave"
              >Save
              </CButton
              >
              <CButton
                  color="primary"
                  class="float-right"
                  @click="editBanner()"
                  v-else
              >Edit
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BannerUseCase from "./app/usecase/index.js"
import FormBanner from "./components/FormBanner";
import TryAgain from "./components/TryAgain";

export default {
  name: "Banners",
  components: {FormBanner, TryAgain},
  data() {
    return {
      data: {
        id: 0,
        banner_type: "",
        main_desktop_image: "",
        main_mobile_image: "",
        alt_text_image: "",
      },
      valueForm: {
        desktop: "",
        mobile: ""
      },
      err: "",
      imageHeightWidthValidate: {
        desktop: {
          max: {
            height: 600,
            width: 2304,
          },
          min: {
            height: 300,
            width: 1152,
          },
        },
        mobile: {
          max: {
            height: 272,
            width: 480,
          },
          min: {
            height: 242,
            width: 426,
          },
        },
      },
      file: {
        desktop: undefined,
        mobile: undefined,
      }
    };
  },
  computed: {
    isSave() {
      return this.valueForm.desktop === '' && this.valueForm.mobile === ''
    },
    isEmpty() {
      return this.data.main_desktop_image === '' && this.data.main_mobile_image === ''
    }
  },
  methods: {
    async fetchDataBanner() {
      try {
        const {data, err} = await BannerUseCase.getOne()
        if (err) {
          this.err = err
          await this.$swal.fire({
            icon: "error",
            text: err,
          })
        } else {
          this.err = ""
          if (data) {
            this.data = data
            this.valueForm.mobile = this.data.main_mobile_image
            this.valueForm.desktop = this.data.main_desktop_image
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        })
      }
    },
    async tryMeAgain() {
      await this.fetchDataBanner()
    },
    retrieveDataMobile(file) {
      this.file.mobile = file
    },
    retrieveDataDesktop(file) {
      this.file.desktop = file
    },
    saveBanner() {
      let err = null
      if (!this.file.mobile) {
        err = "required mobile banner to follow guideline"
      }
      if (!this.file.desktop) {
        err = "required desktop banner to follow guideline"
      }
      if (err) {
        this.$swal.fire({
          icon: "error",
          text: err,
        })
      } else {
        if (this.file.mobile && this.file.desktop) {
          this.processSave()
        }
      }
    },    
    async processSave() {
      await this.$swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading()
          try {
            const {err} = await BannerUseCase.saveOne(this.setFormData())
            if (err) {
              this.$swal.close()
              await this.$swal.fire({
                icon: "error",
                text: err,
              })
            } else {
              this.$swal.close()
              await this.$swal.fire({
                icon: "success",
                text: "banner saved",
              })
              await this.fetchDataBanner()
            }
          } catch (err) {
            this.$swal.close()
            await this.$swal.fire({
              icon: "error",
              text: err,
            })
          }
        }
      })
    },
    /** @return {FormData} */
    setFormData() {
      const formData = new FormData()
      formData.append("banner_type", "homepage")
      formData.append("banner_id", this.data.id)
      formData.append("main_desktop_image", this.file.desktop[0])
      formData.append("main_mobile_image", this.file.mobile[0])
      formData.append("alt_text_image", this.data.alt_text_image)
      return formData
    },
    editBanner() {
      this.valueForm.mobile = ""
      this.valueForm.desktop = ""
    },
    downloadMe() {
      window.open("https://storage.googleapis.com/internal-website/guideline/banner-homepage.zip", '_blank').focus();
    }
  },
  async created() {
    await this.fetchDataBanner()
  },
};
</script>
